import { render, staticRenderFns } from "./SelectableAnnotation.vue?vue&type=template&id=237132f6&scoped=true"
import script from "./SelectableAnnotation.vue?vue&type=script&lang=js"
export * from "./SelectableAnnotation.vue?vue&type=script&lang=js"
import style0 from "./SelectableAnnotation.vue?vue&type=style&index=0&id=237132f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237132f6",
  null
  
)

export default component.exports